export enum WorkOrderSource {
  AnomalyTriggered = 'Anomaly Triggered',
  Manual = 'Manual',
}
